/* ============================================
   DRIFT Theme by WEBEXP, LLC
   DRIFT Feed — Scroll Transitions + Rubber Band Loop
   https://webexp.dev
   ============================================ */

(function () {
  var feed = document.querySelector('[data-section-type="drift-feed"]');
  if (!feed) return;

  var track = feed.querySelector('[data-feed-track]');
  var slides = track.querySelectorAll('[data-feed-slide]');
  if (!track || slides.length === 0) return;

  var SCALE_MIN = 0.7;
  var SCALE_MAX = 1;
  var BLUR_MAX = 6;
  var OPACITY_MIN = 0.3;

  var spacerTop = track.querySelector('[data-feed-spacer="top"]');
  var spacerBottom = track.querySelector('[data-feed-spacer="bottom"]');
  var currentIndex = -1;
  var isLooping = false;
  var counterEl = feed.querySelector('[data-feed-current]');
  var dots = feed.querySelectorAll('[data-feed-dot]');

  var params = new URLSearchParams(window.location.search);
  var resumeIndex = params.has('feed_index') ? parseInt(params.get('feed_index'), 10) : -1;
  var hasResume = resumeIndex >= 0 && resumeIndex < slides.length;

  function setPadding() {
    var trackH = track.offsetHeight;
    var slideH = slides[0] ? slides[0].offsetHeight : 0;
    var pad = Math.max((trackH - slideH) / 2, 0);
    if (spacerTop) spacerTop.style.height = pad + 'px';
    if (spacerBottom) spacerBottom.style.height = pad + 'px';
  }

  function setActive(index) {
    if (index === currentIndex) return;
    if (currentIndex >= 0 && currentIndex < slides.length) {
      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
    }
    currentIndex = index;
    slides[currentIndex].classList.add('is-active');
    if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
    if (counterEl) {
      var display = currentIndex + 1;
      counterEl.textContent = slides.length >= 10 && display < 10 ? '0' + display : '' + display;
    }
  }

  function getVisibleIndex() {
    var viewCenter = track.scrollTop + track.offsetHeight * 0.5;
    var closest = 0;
    var minDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var center = slides[i].offsetTop + slides[i].offsetHeight * 0.5;
      var d = Math.abs(center - viewCenter);
      if (d < minDist) { minDist = d; closest = i; }
    }
    return closest;
  }

  function applyTransforms() {
    var trackH = track.offsetHeight;
    var scrollTop = track.scrollTop;
    var viewCenter = scrollTop + trackH * 0.5;

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var img = slide.querySelector('.drift-feed__image');
      if (!img) continue;

      var slideH = slide.offsetHeight;
      var slideCenter = slide.offsetTop + slideH * 0.5;
      var dist = Math.abs(slideCenter - viewCenter);
      var progress = Math.min(dist / slideH, 1);

      var scale = SCALE_MAX - progress * (SCALE_MAX - SCALE_MIN);
      var blur = progress * BLUR_MAX;
      var opacity = 1 - progress * (1 - OPACITY_MIN);

     if (slide.classList.contains('is-sold-out')) {
  img.style.transform = 'scale(' + scale + ')';
  img.style.filter = 'blur(4px)';
  img.style.opacity = 0.35;
  var soldBadge = slide.querySelector('.drift-badge-stack');
  if (soldBadge) soldBadge.style.opacity = 0.35;
  continue;
}

   img.style.transform = 'scale(' + scale + ')';
img.style.opacity = opacity;

if (blur > 1) {
  img.style.filter = 'blur(' + blur + 'px)';
} else {
  img.style.removeProperty('filter');
}

var badge = slide.querySelector('.drift-badge-stack');
if (badge) badge.style.opacity = opacity;
    }
  }

  var lastScroll = -1;

  function frameLoop() {
    var st = track.scrollTop;
    if (st !== lastScroll) {
      lastScroll = st;
      applyTransforms();
      setActive(getVisibleIndex());
    }
    requestAnimationFrame(frameLoop);
  }

  var settledOnBoundary = false;
  var settleTimer;

  track.addEventListener('scroll', function () {
    settledOnBoundary = false;
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      if (isLooping) return;
      var maxScroll = track.scrollHeight - track.offsetHeight;
      var atBottom = track.scrollTop >= maxScroll - 2;
      var atTop = track.scrollTop <= 2;
      var idx = getVisibleIndex();
      if ((atBottom && idx === slides.length - 1) || (atTop && idx === 0)) {
        settledOnBoundary = true;
      }
    }, 400);
  }, { passive: true });

  track.addEventListener('wheel', function (e) {
    if (isLooping || !settledOnBoundary) return;
    var maxScroll = track.scrollHeight - track.offsetHeight;
    var atBottom = track.scrollTop >= maxScroll - 2;
    var atTop = track.scrollTop <= 2;
    var idx = getVisibleIndex();
    if (atBottom && idx === slides.length - 1 && e.deltaY > 0) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(0);
      setTimeout(function () { isLooping = false; }, 1000);
    }
    if (atTop && idx === 0 && e.deltaY < 0) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(slides.length - 1);
      setTimeout(function () { isLooping = false; }, 1000);
    }
  }, { passive: true });

  var touchStartY = 0;

  track.addEventListener('touchstart', function (e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    if (isLooping || !settledOnBoundary) return;
    var touchEndY = e.changedTouches[0].clientY;
    var diff = touchStartY - touchEndY;
    var maxScroll = track.scrollHeight - track.offsetHeight;
    var atBottom = track.scrollTop >= maxScroll - 2;
    var atTop = track.scrollTop <= 2;
    var idx = getVisibleIndex();
    if (atBottom && idx === slides.length - 1 && diff > 30) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(0);
      setTimeout(function () { isLooping = false; }, 1000);
    }
    if (atTop && idx === 0 && diff < -30) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(slides.length - 1);
      setTimeout(function () { isLooping = false; }, 1000);
    }
  }, { passive: true });

  function scrollToIndex(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;
    var slide = slides[index];
    var slideCenter = slide.offsetTop + slide.offsetHeight * 0.5;
    var targetScroll = slideCenter - track.offsetHeight * 0.5;
    setActive(index);
    track.scrollTo({ top: targetScroll, behavior: 'smooth' });
  }

  function forceScrollToFirst() {
    if (!slides.length) return;
    var slide = slides[0];
    var slideCenter = slide.offsetTop + slide.offsetHeight * 0.5;
    var targetScroll = slideCenter - track.offsetHeight * 0.5;
    track.scrollTop = Math.max(0, targetScroll);
  }

  if (spacerTop) {
    spacerTop.addEventListener('click', function () {
      scrollToIndex(currentIndex - 1);
    });
  }

  if (spacerBottom) {
    spacerBottom.addEventListener('click', function () {
      scrollToIndex(currentIndex + 1);
    });
  }

  if (dots.length > 0) {
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-feed-dot'), 10);
        scrollToIndex(index);
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    var tag = document.activeElement && document.activeElement.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    if (e.key === 'ArrowDown' || e.key === 'j') {
      e.preventDefault();
      scrollToIndex(currentIndex + 1);
    } else if (e.key === 'ArrowUp' || e.key === 'k') {
      e.preventDefault();
      scrollToIndex(currentIndex - 1);
    }
  });

  for (var s = 0; s < slides.length; s++) {
    slides[s].addEventListener('click', function (e) {
      var slideIndex = parseInt(this.getAttribute('data-feed-slide'), 10);
      if (slideIndex === currentIndex) return;
      if (e.target.closest('[data-feed-info]') && e.target.closest('.is-active')) return;
      e.preventDefault();
      scrollToIndex(slideIndex);
    });
  }

  track.addEventListener('dragstart', function (e) { e.preventDefault(); });

  window.addEventListener('resize', function () {
    setPadding();
    applyTransforms();
  });

  track.style.scrollSnapType = 'none';
  setPadding();
  void track.offsetHeight;

  if (hasResume) {
    var resumeSlide = slides[resumeIndex];
    var resumeCenter = resumeSlide.offsetTop + resumeSlide.offsetHeight * 0.5;
    var resumeTarget = resumeCenter - track.offsetHeight * 0.5;
    track.scrollTop = Math.max(0, resumeTarget);
    applyTransforms();
    setActive(resumeIndex);
  } else {
    forceScrollToFirst();
    applyTransforms();
    setActive(0);
  }

  requestAnimationFrame(frameLoop);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      track.style.scrollSnapType = '';
      track.classList.add('is-ready');
    });
  });
})();